document.addEventListener('DOMContentLoaded', function() {
  // Selettori multipli
  const paragraphs = document.querySelectorAll(
    '.metafield-multi_line_text_field, .template-collection .group-block__content:not(:has(h2)) .body'
  );

  if (!paragraphs.length) return;

  paragraphs.forEach(paragraph => {
    const fullHeight = paragraph.scrollHeight;
    const lineHeight = parseFloat(window.getComputedStyle(paragraph).lineHeight);
    const visibleHeight = lineHeight * 6;

    if (fullHeight > visibleHeight) {
      const button = document.createElement('button');
      button.className = 'read-more-btn';
      button.textContent = 'Leggi di più';
      paragraph.insertAdjacentElement('afterend', button);

      button.addEventListener('click', () => {
        const isExpanded = paragraph.classList.toggle('expanded');
        button.textContent = isExpanded ? 'Mostra meno' : 'Leggi di più';

        // Altezza header
        const header = document.querySelector('header');
        const headerHeight = header ? header.offsetHeight : 0;

        // Se chiude, torna all’inizio del blocco
        if (!isExpanded) {
          const paragraphTop = paragraph.getBoundingClientRect().top + window.scrollY - headerHeight - 10;
          window.scrollTo({ top: paragraphTop, behavior: 'smooth' });
        }
      });
    }
  });
});
